import { Routes } from '@angular/router';
import { CONFIRM_EMAIL_ROUTES } from '../confirm-email/confirm-email-routes';
import { ANGULARJS_ROUTE_DATA } from './legacy-routes';
import { ROOT_ROUTE_DATA } from './root-routes';

/**
 * This set of routes are for handling existing explicit AngularJS routes.
 */
export const ANGULARJS_ROUTES: Routes = [
    {
        path: ANGULARJS_ROUTE_DATA.CONFIRM_EMAIL.PATH,
        redirectTo: CONFIRM_EMAIL_ROUTES.CONFIRM_EMAIL.PATH,
    },
    {
        path: ANGULARJS_ROUTE_DATA.LOGOUT.PATH,
        redirectTo: ROOT_ROUTE_DATA.LOGOUT.PATH,
    },
    {
        path: ANGULARJS_ROUTE_DATA.LANDING.PATH,
        redirectTo: ROOT_ROUTE_DATA.LANDING.PATH,
    },
];

export const LEGACY_TECHNOLOGY_ROUTES = [...ANGULARJS_ROUTES];
